import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

// Read-only: entries are written by the API itself, super users can only list/inspect them
const auditLogsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAuditLogs: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `auditLogs${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('AuditLog'),
        }),
        getAuditLog: build.query({
            query: (id) => {
                return {
                    url: `auditLogs/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('AuditLog', result),
        }),
    }),
    overrideExisting: false,
})

export default auditLogsApi

export const {useGetAuditLogsQuery, useGetAuditLogQuery} = auditLogsApi
